import * as Utils from 'Assets/Utils'
import { ACTION_GET_QUESTION_PROJECT } from 'Modules/Configurations/Project/QuestionProject'
import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([]))

/* Types */
export const ACTION_GET_QUESTION_TYPE = 'ACTION_GET_QUESTION_TYPE'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_GET_QUESTION_TYPE:
			return state.set('Search', new Immutable.List(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const searchQuestionType = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchQuestionType',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_QUESTION_TYPE, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchQuestionTypeByName = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET_QUESTION_PROJECT, Obj: {} })
		return new ClientHttpRequest({
			service: 'api/searchQuestionTypeByName',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}




// WEBPACK FOOTER //
// ./src/modules/Catalogs/QuestionType/QuestionType.js